var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBox = function SvgBox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5018 18.7507L6.28449 11.104C6.81622 10.3231 7.47151 9.68357 8.15287 9.3062L8.15312 9.30607L16.6081 4.6194L16.6081 4.61941L16.6119 4.61731C17.3669 4.19342 18.4123 3.95866 19.5018 3.95866C20.5914 3.95866 21.6367 4.19342 22.3918 4.61732L22.3955 4.6194L30.8505 9.30607L30.8507 9.3062C31.5321 9.68358 32.1874 10.3231 32.7191 11.104L19.5018 18.7507Z",
    fill: "#B388FF",
    stroke: "#B388FF",
    strokeWidth: 1.58333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.7093 33.9994C17.9151 33.9145 17.1805 33.7023 16.611 33.3826L16.6073 33.3805L8.1523 28.6939L8.15198 28.6937C7.34717 28.2481 6.56921 27.4346 5.99033 26.4528C5.41141 25.471 5.07682 24.3977 5.07682 23.4805V14.5188C5.07682 13.8939 5.23837 13.1959 5.52969 12.4963L18.7093 20.1212V33.9994Z",
    fill: "#B388FF",
    stroke: "#B388FF",
    strokeWidth: 1.58333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.851 28.6937L30.8506 28.6939L22.3956 33.3805L22.3919 33.3826C21.8224 33.7023 21.0878 33.9145 20.2936 33.9994V20.1212L33.4733 12.4963C33.7646 13.1959 33.9261 13.8939 33.9261 14.5188V23.4805C33.9261 24.3977 33.5915 25.471 33.0126 26.4528C32.4337 27.4346 31.6558 28.2481 30.851 28.6937Z",
    fill: "#B388FF",
    stroke: "#B388FF",
    strokeWidth: 1.58333
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "box.1855f5a46224ca62974d6e7c3e754349.svg";